import { createSelector } from 'reselect'
import { currentUserSelector } from 'selectors/currentUser'

export const getUserId = (state, props) => {
  return state.kanbo.userActivities.userId
}

export const getIsLoaded = (state, props) => {
  return state.kanbo.userActivities.isLoaded
}

export const getIsLoading = (state, props) => {
  return state.kanbo.userActivities.isLoading
}

export const getCursor = (state, props) => {
  return state.kanbo.userActivities.cursor
}

export const getActivities = (state, props) => {
  return state.kanbo.userActivities.activities
}

export const getActivitiesById = (state, props) => {
  return state.kanbo.userActivities.activitiesById
}

export const makeActivitiesSelector = () => createSelector(
  [getActivities, getActivitiesById],
  (activities, activitiesById) => {
    return activities.map(id => activitiesById[id])
  }
)

export const getActivitiesDetailLevel = (state, props) => {
  return state.kanbo.currentUser.settings.activitiesDetailLevel
}

export default () => {
  const activitiesSelector = makeActivitiesSelector()

  return createSelector(
    [
      getUserId,
      getIsLoaded,
      getIsLoading,
      getCursor,
      currentUserSelector,
      activitiesSelector,
      getActivitiesDetailLevel
    ],
    (
      userId,
      isLoaded,
      isLoading,
      cursor,
      currentUser,
      activities,
      activitiesDetailLevel
    ) => ({
      userId,
      isLoaded,
      isLoading,
      cursor,
      currentUser,
      activities,
      activitiesDetailLevel
    })
  )
}
